<h1 mat-dialog-title>Change Password</h1>
<div mat-dialog-content [formGroup]="passwordForm">
  <div fxLayout="column">
    <mat-form-field fxFlex="100">
      <mat-label>New Password</mat-label>
      <input matInput formControlName="password" type="password" />
      <mat-error *ngIf="passwordControl.errors?.characterLimit">
        {{ 'PASSWORD.ERROR.CHARACTERLIMIT' | translate }}
      </mat-error>
      <mat-error *ngIf="passwordControl.errors?.mustBeNumeric"
        >{{ 'PASSWORD.ERROR.MUSTBENUMERIC' | translate }}
      </mat-error>
      <mat-error *ngIf="passwordControl.errors?.invalidSpecialCharacter">
        {{ 'PASSWORD.ERROR.INVALIDSPECIALCHARACTER' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field fxFlex="100">
      <mat-label>Confirm Password</mat-label>
      <input
        matInput
        formControlName="passwordConfirm"
        type="password"
        placeholder="Confirm Password"
      />
      <mat-error *ngIf="passwordConfirmControl.errors?.notMatch">{{
        'PASSWORD.ERROR.CONFIRMATIONDOESNOTMATCH' | translate
      }}</mat-error>
    </mat-form-field>
  </div>
</div>
<mat-dialog-actions align="end">
  <button
    mat-button
    class="ag-mat-button-primary"
    type="button"
    (click)="changePassword()"
    [disabled]="passwordForm.invalid"
  >
    <mat-icon *ngIf="submitting">
      <mat-spinner diameter="20"></mat-spinner>
    </mat-icon>
    Submit
  </button>
  <button mat-button mat-dialog-close type="button">Close</button>
</mat-dialog-actions>
